import { Col, Row } from "reactstrap";

function RenderLayoutCampos({ campos, layout, renderConteudoCampo }) {
  //Monta as linhas do layout com os campos
  function montarLinhasCampos(campos, layout) {
    const linhas = [];

    let linhaAtual = [];
    let colunasUsadas = 0;
    let layoutIndex = 0;

    for (const campo of campos) {
      const limiteCamposLinha =
        layout[layoutIndex] || layout[layout.length - 1];

      const sizeCampo = Number(campo.col_size) || null;

      //Campo full width sempre força nova linha
      if (sizeCampo === 12) {
        if (linhaAtual.length) {
          linhas.push(linhaAtual);
          linhaAtual = [];
          colunasUsadas = 0;
          layoutIndex++;
        }

        linhas.push([campo]);
        continue;
      }

      //Se estourar 12 colunas OU estourar layout de campos → quebra linha
      const vaiEstourarGrid = sizeCampo && colunasUsadas + sizeCampo > 12;

      const vaiEstourarLayout = linhaAtual.length >= limiteCamposLinha;

      if (vaiEstourarGrid || vaiEstourarLayout) {
        linhas.push(linhaAtual);
        linhaAtual = [];
        colunasUsadas = 0;
        layoutIndex++;
      }

      linhaAtual.push(campo);

      if (sizeCampo) {
        colunasUsadas += sizeCampo;
      }
    }

    if (linhaAtual.length) {
      linhas.push(linhaAtual);
    }

    return linhas;
  }

  const linhas = montarLinhasCampos(campos, layout);

  return linhas.map((linha, indexLinha) => {
    const totalDefinido = linha.reduce(
      (sum, campo) => sum + Number(campo.col_size || 0),
      0,
    );

    const camposSemSize = linha.filter((c) => !c.col_size);
    const restante = 12 - totalDefinido;

    const sizePadrao =
      camposSemSize.length > 0
        ? Math.floor(restante / camposSemSize.length)
        : 0;

    return (
      <Row key={indexLinha}>
        {linha.map((campo) => {
          let size = campo.col_size;

          if (!size) {
            size = sizePadrao;

            const isUltimoSemSize =
              camposSemSize[camposSemSize.length - 1] === campo;

            if (isUltimoSemSize) {
              const usadoAteAgora =
                totalDefinido + sizePadrao * (camposSemSize.length - 1);

              size = 12 - usadoAteAgora;
            }
          }

          return (
            <Col sm={size} md={size} lg={size} key={campo.id} className="mb-1">
              {renderConteudoCampo(campo)}
            </Col>
          );
        })}
      </Row>
    );
  });
}

export default RenderLayoutCampos;
